import { ArchErrors, TeethArchEnum, ToothErrors } from "@jasper/client-models";

export default {
  common: {
    errorOccurred: "Une erreur est survenue. Veuillez réessayer.",
    errorNotificationTitle: "Erreur",
    errorNotificationMessage: "Une erreur est survenue. Veuillez réessayer.",
    confirm: "Confirmer",
    cancel: "Annuler",
    productNotFound: "Produit introuvable pour cette configuration.",
  },
  orderDescription: {
    productsCount_one: "{{count}} prothèse",
    productsCount_other: "{{count}} prothèses",
    defaultTitle: "Commande",
  },
  shadeTypes: {
    VITA_CLASSIC: "Vita Classical",
    VITA_3D_MASTER: "Vita 3D Master",
    CHROMASCOP: "Chromascop",
    SR_VIVODENT_SPE: "Sr Vivodent Spe",
  },
  arches: {
    [TeethArchEnum.MAXILLARY]: "Maxillaire",
    [TeethArchEnum.MANDIBULAR]: "Mandibulaire",
  },
  steps: {
    arch: {
      title: "Sélection de l'arcade",
      hint: "Cliquez sur une dent pour sélectionner son arcade entière. Sélectionnez les deux arcades pour créer un produit par arcade.",
      errors: {
        [ArchErrors.NO_ARCH_SELECTED]:
          "Vous devez sélectionner au moins une arcade.",
        [ArchErrors.INCOMPLETE_ARCH]: "L'arcade sélectionnée est incomplète.",
      },
    },
    teeth: {
      title: "Sélection des dents",
      noToothSelected: "Aucune dent sélectionnée",
      bulk: {
        hint: "Sélectionnez plusieurs dents pour créer une prothèse par dent.",
      },
      errors: {
        [ToothErrors.INVALID_TOOTH]: "La dent sélectionnée n'est pas valide.",
        [ToothErrors.NON_UNIQUE_TEETH]:
          "Vous ne pouvez sélectionner qu'une seule dent pour ce type de prothèse.",
        [ToothErrors.NON_ADJACENT_TEETH]:
          "Les dents sélectionnées doivent être adjacentes.",
        [ToothErrors.NON_MULTI_TEETH]:
          "Vous devez sélectionner au moins deux dents.",
        [ToothErrors.NO_TOOTH_SELECTED]:
          "Vous devez sélectionner au moins une dent.",
        unexpected: "Une erreur inattendue est survenue. Veuillez réessayer.",
        MISSING_IMPLANTED_TOOTH:
          "Vous devez sélectionner au moins une dent implanto-portée.",
      },
    },
    adjacentTeeth: {
      labels: {
        element_one: "élément",
        element_other: "éléments",
      },
    },
    waxUpType: {
      title: "Type de wax-up",
      NUMERICAL: "Numérique",
      PHYSICAL: "Physique",
      NUMERICAL_AND_PHYSICAL: "Numérique et physique",
    },
    inlayCore: {
      title: "Caractéristiques de l'inlay-core",
      productNotFound: "Produit introuvable pour cette configuration.",
      choicesUnavailable:
        "Les matériaux et les scan posts n'ont pas pu être chargés. Veuillez réessayer.",
    },
    inlayCoreCrown: {
      title: "Couronne",
      createCrownLabel: "Réaliser aussi la couronne sur ce faux moignon",
      createCrownDescription: "Décochez pour ne commander que le faux moignon",
    },
    implantConnection: {
      title: "Connectique implantaire",
      productNotFound: "Produit introuvable pour cette configuration.",
      choicesUnavailable:
        "Les références d'implants n'ont pas pu être chargées. Veuillez réessayer.",
    },
    abutment: {
      title: "Pilier & Analogue",
    },
    implantRetention: {
      title: "Mode de rétention",
    },
  },
  bulk: {
    arches: {
      MAXILLARY: "maxillaire",
      MANDIBULAR: "mandibulaire",
    },
    errorNotificationTitle: "Erreur lors de la création groupée",
    errorNotificationMessage:
      "Une erreur est survenue lors de la mise à jour des prothèses. Veuillez réessayer.",
  },
};
